import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function ThreelinesIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "20"}
      height={height || "13.333"}
      viewBox="0 0 20 13.333"
    >
      <g id="Menu" transform="translate(-25 -88)">
        <path
          id="Path_10020"
          data-name="Path 10020"
          d="M3,19.333H23V17.111H3Zm0-5.556H23V11.556H3ZM3,6V8.222H23V6Z"
          transform="translate(22 82)"
          fill={color || "#bbb"}
        />
      </g>
    </svg>
  );
}
